// == Import npm
import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Select, Radio, Steps, Empty, TimePicker } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { searchVisitor, updateVisit, updateVisitsFromUser } from "services/features/VisitsSlice";
import classNames from "classnames";
import debounce from "lodash.debounce";

// == Import SCSS
import "./modalUpdate.less";

// == import components
import ModalAddVisitor from "../../ModalAddVisitor/ModalAddVisitor";

// == Import icons
import { MdPersonAdd, MdPerson, MdDelete } from "react-icons/md";

// == import i18n
import { useTranslation } from "react-i18next";
import { range } from "ramda";

const { Step } = Steps;

const ModalUpdate = ({ isVisible, setVisible, user, visit, initialSearch }) => {
  const [t] = useTranslation();
  const { visitorList } = useSelector(state => state.visits);

  const [isModalAddvisitorVisible, setIsModalAddvisitorVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isDisplayCaract, setIsDisplayCaract] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [loaderSearch, setLoaderSearch] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const handleUpdate = values => {
    dispatch(
      updateVisit(
        visit.id,
        values.startDate.toISOString(),
        values.endDate.toISOString(),
        values.visitors.map(v => v.value),
        user.id,
      ),
    );
    dispatch(updateVisitsFromUser(user));
    setCurrent(0);

    setVisible(false);
  };

  const handleSearch = value => {
    if (value) {
      if (value.length >= 3) {
        setLoaderSearch(true);
        dispatch(searchVisitor(value)).finally(() => {
          setLoaderSearch(false);
        });
        setIsDisplayCaract(false);
        setIsDisplay(true);
      }
    }
    if (value.length === 0) {
      setIsDisplayCaract(true);
      setLoaderSearch(false);
    }
    if (value.length < 3 && value.length > 0) {
      setIsDisplayCaract(true);
      dispatch(searchVisitor(""));
      setLoaderSearch(false);
    }
  };

  const handleSearchDebounced = debounce(handleSearch, 500);

  const handleOk = () => {
    setVisible(false);
    form.resetFields();
    dispatch(searchVisitor(""));
    setSearchValue("");
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    dispatch(searchVisitor(""));
    setSearchValue("");
  };

  const { Option } = Select;

  const showModal = () => {
    setIsModalAddvisitorVisible(true);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onCreateUser = user => {
    const values = form.getFieldsValue();
    form.setFieldsValue({
      ...values,
      visitors: [
        ...(values.visitors || []),
        {
          value: user.id,
          label: [user.firstname, " ", user.lastname],
          key: user.id,
        },
      ],
    });
  };

  const cssClassDisplayCaract = classNames("noResult__text", {
    "noResult__text--display": isDisplayCaract,
  });

  const cssClassDisplaytext = classNames("noResult__text", {
    "noResult__text--display": !isDisplayCaract,
  });

  const cssClassDisplay = classNames("searchBar__result__loader", {
    "searchBar__result__loader--display": isDisplay,
  });

  useEffect(() => {
    if (initialSearch) {
      handleSearchDebounced(initialSearch);
    }
  }, [handleSearchDebounced, initialSearch]);

  return (
    <div>
      <Modal
        width={600}
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
      >
        <Steps current={current} labelPlacement="vertical">
          <Step title={t("AddUpdateVisitor")} />
          <Step title={t("UpdateAVisit")} />
        </Steps>

        <div className="steps-content">
          <Form
            style={{ height: "500px" }}
            form={form}
            onFinish={handleUpdate}
            onValuesChange={changedValues => {
              if (changedValues.startDate) {
                form.setFieldsValue({ endDate: moment(changedValues.startDate).add(2, "hours") });
              }
            }}
            initialValues={{
              visitors: visit.visitors.map(v => ({
                label: v.firstname + " " + v.lastname,
                value: v.id,
              })),
              startDate: moment(visit.startDate),
              endDate: moment(visit.endDate),
              resident: user.id,
            }}
          >
            <div
              style={{
                display: current < 1 ? "flex" : "none",
                justifyContent: "space-between",
                flexFlow: "column",
                height: "100%",
              }}
            >
              <div>
                <Form.Item label="Résident" name="resident" style={{ display: "none" }}>
                  <Radio.Group>
                    <Radio value={user.id}>
                      {user.firstname} {user.lastname}
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item className="select" name="visitors" shouldUpdate>
                  <Select
                    onSelect={() => {
                      setSearchValue("");
                    }}
                    autoFocus={initialSearch.length > 0}
                    defaultOpen={!!initialSearch}
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder={t("SearchByFirstOrLastNameOfTheVisitor")}
                    onSearch={value => {
                      setSearchValue(value);
                      handleSearchDebounced(value);
                    }}
                    searchValue={searchValue || initialSearch}
                    filterOption={false}
                    //showSearch
                    // autoClearSearchValue={false}
                    // searchValue={searchValue}
                    virtual={false}
                    onBlur={() => {
                      // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                      window.scrollTo(0, 0);
                    }}
                    labelInValue={true}
                    dropdownRender={menu => (
                      <div>
                        {visitorList.length > 0 ? (
                          menu
                        ) : (
                          <>
                            {loaderSearch ? (
                              <p className={cssClassDisplay}>{t("Loading")}</p>
                            ) : (
                              <>
                                <p
                                  className={cssClassDisplayCaract}
                                  style={{ textAlign: "center" }}
                                >
                                  {" "}
                                  {t("EnterLetters")} <br /> {t("RespectTheAccents")}
                                </p>
                                <Empty
                                  className={cssClassDisplaytext}
                                  description={t("NoVisitor")}
                                />{" "}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  >
                    {visitorList.map((user, index) => (
                      <Option key={user.id} value={user.id}>
                        {user.firstname} {user.lastname}
                        {user.company === undefined ? null : `(${user.company})`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <p className="text__search">{t("FindVisitors")}</p>

                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue, setFieldsValue }) => (
                    <>
                      <div className="modalUpdateVisits__modal__resident">
                        <p className="modalUpdateVisits__modal__resident__title">{t("Resident")}</p>
                        <p className="modalUpdateVisits__modal__resident__name">
                          <MdPerson />
                          {user.firstname + " " + user.lastname}
                        </p>
                      </div>

                      <div className="modalUpdateVisits__modal__visitors">
                        {getFieldValue("visitors").length > 1 ? (
                          <p className="modalUpdateVisits__modal__visitors__title">
                            {t("Visitor")}s ({getFieldValue("visitors").length}){" "}
                          </p>
                        ) : (
                          <p className="modalUpdateVisits__modal__visitors__title">
                            {t("Visitor")} ({getFieldValue("visitors").length}){" "}
                          </p>
                        )}
                        {getFieldValue("visitors").map(v => (
                          <div className="modalUpdateVisits__modal__visitors__name">
                            <p className="modalUpdateVisits__modal__visitors__name__text">
                              <MdPerson /> {v.label}
                            </p>
                            <Button
                              className="modalUpdateVisits__modal__visitors__name__delete"
                              onClick={() => {
                                setFieldsValue({
                                  visitors: getFieldValue("visitors").filter(
                                    visitor => visitor.value !== v.value,
                                  ),
                                });
                              }}
                            >
                              <MdDelete />
                            </Button>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </Form.Item>
              </div>

              <Form.Item noStyle shouldUpdate>
                {() => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexFlow: "row",
                      marginTop: "16px",
                    }}
                  >
                    <Button
                      type="default"
                      size="large"
                      style={{ marginRight: "16px", width: "250px" }}
                      onClick={showModal}
                      onBlur={() => {
                        // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                        window.scrollTo(0, 0);
                      }}
                      icon={<MdPersonAdd style={{ verticalAlign: "-2px", marginRight: "8px" }} />}
                    >
                      {t("AddAVisitor")}
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      style={{ width: "250px" }}
                      disabled={(form.getFieldValue("visitors") || []).length === 0}
                      className={classNames("btn__next", {
                        "btn__next--disabled": (form.getFieldValue("visitors") || []).length === 0,
                      })}
                      onClick={() => next()}
                      onBlur={() => {
                        // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                        window.scrollTo(0, 0);
                      }}
                    >
                      {t("Next")}
                    </Button>
                  </div>
                )}
              </Form.Item>
            </div>

            <div
              style={{
                display: current === 1 ? "flex" : "none",
                justifyContent: "space-between",
                flexFlow: "column",
                height: "100%",
              }}
            >
              <div>
                <Form.Item
                  trigger="onSelect"
                  label={t("DateStart")}
                  rules={[{ required: true }]}
                  name="startDate"
                  labelCol={{ style: { width: 300 } }}
                >
                  <TimePicker
                    showTime={{ format: "HH:mm" }}
                    format="HH:mm"
                    minuteStep={15}
                    placeholder={t("SelectDate")}
                  />
                </Form.Item>
                <Form.Item shouldUpdate>
                  {({ getFieldValue }) => (
                    <Form.Item
                      trigger="onSelect"
                      label={t("DateEnd")}
                      rules={[{ required: true }]}
                      name="endDate"
                      labelCol={{ style: { width: 300 } }}
                    >
                      <TimePicker
                        showTime={{ format: "HH:mm" }}
                        format="HH:mm"
                        placeholder={t("SelectDate")}
                        disabledHours={() =>
                          moment(getFieldValue("startDate")).minutes() >=
                          moment(getFieldValue("endDate")).minutes()
                            ? range(0, moment(getFieldValue("startDate")).add(1, "hours").hour())
                            : moment(getFieldValue("startDate")).hours() <=
                              moment(getFieldValue("endDate")).hours()
                            ? range(0, moment(getFieldValue("startDate")).hour())
                            : []
                        }
                        disabledMinutes={() =>
                          moment(getFieldValue("startDate")).hour() ===
                          moment(getFieldValue("endDate")).hour()
                            ? range(0, moment(getFieldValue("startDate")).minutes())
                            : []
                        }
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </div>

              <div
                style={{
                  display: "flex",
                  flexFlow: "row",
                  justifyContent: "center",
                }}
              >
                <Button
                  type="default"
                  size="large"
                  style={{ marginRight: "16px", width: "250px" }}
                  onClick={() => prev()}
                  onBlur={() => {
                    // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                    window.scrollTo(0, 0);
                  }}
                >
                  {t("Previous")}
                </Button>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  style={{ width: "250px" }}
                  onBlur={() => {
                    // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                    window.scrollTo(0, 0);
                  }}
                >
                  {t("UpdateVisits")}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      <ModalAddVisitor
        isVisible={isModalAddvisitorVisible}
        setVisible={setIsModalAddvisitorVisible}
        onCreateUser={onCreateUser}
        setSearchValue={setSearchValue}
        setSearch={setSearchValue}
      />
    </div>
  );
};

export default ModalUpdate;
